<!-- Booleans in VM are being considered string @ runtime, boolean validationsn need to be changed once they are the proper type @ runtime-->
  <fieldset [disabled]="isWorkflowOnSubscriber">
    <div class="row d-flex align-items-center">
      <div class="col-sm-6">
        <h2 class="text-primary mb-0">
          {{cardConfiguration.title}}
        </h2>
      </div>
      <div class="col-sm-6 text-end">
        <button aria-label="Nova entrada" [ngClass]="!expandNewEntry ? '' : 'disabled'"
                (click)="expandNewEntry=!expandNewEntry" type="button"
                class="btn btn-link disable-on-fieldset"><span class="icon-add"></span> {{'CardFamilyBenefits.FamilyBenefitsTable.AddItem' | translate}}</button>
      </div>
    </div>

    <!--New table entry inputs-->
    <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
      <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
        <span aria-hidden="true" class="icon-close text-primary"></span>
      </button>
      <h3 class="text-primary">{{'CardFamilyBenefits.FamilyBenefitsTable.AddItem' | translate}}</h3>
      <family-benefits-table-edit [itemList]="cardData.familyBenefitsList" (listChanged)="onFamilyBenefitsListChanged($event)"></family-benefits-table-edit>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">{{'CardFamilyBenefits.FamilyBenefitsTable.BenefitTypeHeader' | translate}}</th>
          <th scope="col">{{'CardFamilyBenefits.FamilyBenefitsTable.NameHeader' | translate}}</th>
          <th scope="col">{{'CardFamilyBenefits.FamilyBenefitsTable.DisabledHeader' | translate}}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let tableItem of cardData.familyBenefitsList; let i = index">
          <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
            <td>{{tableItem.benefitTypes.benefitTypesList | commonDataList : benefitTypes : 'code' : 'desc' : ';'}}</td>
            <td>{{tableItem.name}}</td>
            <td>{{tableItem.disabled | commonData : yesNo : 'value' : 'desc'}}</td>
            <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
              <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
                <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'" ></span>
              </button>
              <button *ngIf="!disableTableRemoveIcons" type="button" class="btn-icon" aria-label="Apagar" (click)="removeFromList(cardData.familyBenefitsList , i,$event)">
                <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
            <td class="p-0" colspan="4" id="collapseBasic">
              <div class="ml-5 mr-5 p-4">
                <family-benefits-table-edit [itemList]="cardData.familyBenefitsList" [editIndex]="i" (listChanged)="onFamilyBenefitsListChanged($event)"></family-benefits-table-edit>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    </fieldset>

<!--<pre>{{cardData | json}}</pre>-->
